import { ShoppingBag, Package, Tag } from "lucide-react";
import { CampaignType } from "@/constants/campaign-types";

export const campaignTypesInfo = [
  {
    id: CampaignType.PRO013,
    title: "Leve X Pague Y",
    technicalCode: "PRO013",
    description: "Promoções aplicadas a departamentos ou grupos de produtos",
    details: "Multi-loja • 8 tipos de desconto",
    icon: ShoppingBag,
    enabled: true,
    modalInfo: {
      objetivo: "Criar promoções do tipo 'Leve X Pague Y' aplicadas a departamentos ou grupos de produtos inteiros, permitindo configurações flexíveis de desconto.",
      caracteristicas: [
        "Aplicação em departamentos completos (ex: Departamento 10)",
        "Ou aplicação em grupos de produtos específicos",
        "Suporta múltiplas lojas simultaneamente (código 999 para todas)",
        "8 tipos de desconto disponíveis (integral, percentual, valor fixo, brinde)",
        "Configuração de 'Leve X' e 'Pague Y'",
      ],
      regras: [
        "Se usar grupos, apenas 1 departamento é permitido",
        "Obrigatório definir pelo menos 1 departamento ou grupo",
        "Multi-loja: cria 1 registro por loja ou 1 registro com código 999",
      ],
    },
  },
  {
    id: CampaignType.PRO014,
    title: "Leve X Pague Y (Itens)",
    technicalCode: "PRO014",
    description: "Promoções aplicadas a itens específicos cadastrados manualmente",
    details: "Multi-loja • 8 tipos de desconto • Itens específicos",
    icon: Package,
    enabled: true,
    modalInfo: {
      objetivo: "Criar promoções do tipo 'Leve X Pague Y' para produtos específicos, com controle individual por SKU.",
      caracteristicas: [
        "Seleção manual de produtos (por SKU)",
        "Controle granular: ativar/desativar cada item",
        "Upload em massa via planilha Excel",
        "Suporta múltiplas lojas simultaneamente",
        "8 tipos de desconto disponíveis",
      ],
      regras: [
        "Produtos devem ser cadastrados manualmente ou via Excel",
        "Cada item pode ser ativado/desativado independentemente",
        "Multi-loja: cria 1 registro por loja ou 1 registro com código 999",
        "Produtos inválidos são ignorados durante o upload",
      ],
    },
  },
  {
    id: CampaignType.PRO017,
    title: "Combo Moderno",
    technicalCode: "PRO017",
    description: "Combos com múltiplas listas de produtos (2 a 10 listas)",
    details: "Todas as lojas • Múltiplas listas • Alta performance",
    icon: Tag,
    enabled: true,
    modalInfo: {
      objetivo: "Criar combos modernos onde o cliente compra 1 item de cada lista e recebe desconto no total.",
      caracteristicas: [
        "De 2 a 10 listas de produtos diferentes",
        "Cliente escolhe 1 produto de cada lista",
        "Desconto aplicado no valor total ou por percentual",
        "Automaticamente válido em todas as lojas (código 999)",
        "Alta performance otimizada para processamento rápido",
      ],
      regras: [
        "Mínimo de 2 listas, máximo de 10 listas",
        "Cada lista deve ter pelo menos 1 produto",
        "Cliente deve comprar 1 item de cada lista para ativar o desconto",
        "Sempre multi-loja (não permite seleção individual de lojas)",
      ],
    },
  },
];
